import { logError } from '@cp/src/utils/ApiHelper';
import firebase from 'firebase/app';
import 'firebase/storage';

const storage = firebase.storage();

export const downloadUrl = async (filename: string) => {
  const storageRef = storage.ref(filename);
  try {
    const url = await storageRef.getDownloadURL();
    return url;
  } catch (error) {
    logError(error);
    return null;
  }
};
